module.exports = __webpack_public_path__ + "img/pop_fri_frame.c8312d02.png";